import { get } from 'lodash';
import { useQuery } from 'react-query';

function useShare({ config }) {
  const pageKey = get(config, ['page', 'key'], null);

  const { data } = useQuery(['share-service', pageKey], () => {
    return {};
  }, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const triggerShare = () => {
    // format?
  };

  return { data, triggerShare };
}

export default useShare;
